import {
    USERALL_LOAD,
    USERALL_LOADING,
    USERALL_ERROR,

    USER_LOADING,
    USER_LOADED,
    AUTH_ERROR,

    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGIN_LOADING,

    LOGOUT_SUCCESS,
    USER_LOADED_ALL,

    USER_EDIT_LOADING,
    USER_EDIT_LOADED,
    USER_EDIT_ERROR,
    USER_EDIT_RESET,

    USERS_TIPO_LOADED,
    USERS_TIPO_LOADING,
    USERS_TIPO_ERROR,

    USER_NATURALISTA_LOADED,
    USER_NATURALISTA_ERROR,
    USER_NATURALISTA_LOADING,
    USER_NATURALISTA_COUNT_LOADED,

    USERS_DATA_LOADING,
    USERS_DATA_LOADED,
    USERS_DATA_ERROR,

    REGISTER_USER_LOADING,
    REGISTER_USER_LOADED,
    REGISTER_USER_ERROR
} from './../types/usertypes';

const INITIAL_STATE = {
    userNatur: [],
    userNaturCount:[],
    userNaturLoaded: false,
    userNaturLoading: false,
    userNaturError: '',

    isLoading: false,
    isAuthenticated: localStorage.getItem('isAuthenticated'),
    is_superuser: localStorage.getItem('isAuthenticated'),
    tipo: localStorage.getItem('tipo'),
    user: null,
    userall: null,
    error: '',
    
    isLoadingEdit: false,
    isLoadedEdit: false,
    userEdit: [],
    errorEdit: '',

    tipouser: [],
    tipouser_load: false,
    tipouser_loading:false,
    tipouser_error: '',

    userdata:[],
    userdataLoading: false,
    userdataLoaded: false,
    userdataError: '',

    register: [],
    registerLoading: false,
    registerLoaded: false,
    registerError: '',

    token: localStorage.getItem('token')
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case REGISTER_USER_LOADING:
            return {
                ...state,
                register: [],
                registerLoaded: false,
                registerLoading:true,
                registerError: '',
            };
        case REGISTER_USER_LOADED:
            return {
                ...state,
                register: action.payload,
                registerLoaded: true,
                registerLoading:false,
                registerError: '',
            };
        case REGISTER_USER_ERROR:
            return {
                ...state,
                register: [],
                registerLoaded: false,
                registerLoading: false,
                registerError: action.payload,
            };

        case USERS_DATA_LOADING:
            return {
                ...state,
                userdata: [],
                userdataLoaded: false,
                userdataLoading:true,
                userdataError: '',
            };
        case USERS_DATA_LOADED:
            return {
                ...state,
                userdata: action.payload,
                userdataLoaded: true,
                userdataLoading:false,
                userdataError: '',
            };
        case USERS_DATA_ERROR:
            return {
                ...state,
                userdata: [],
                userdataLoaded: false,
                userdataLoading: false,
                userdataError: action.payload,
            };


        case USER_NATURALISTA_LOADING:
            return {
                ...state,
                userNatur: [],
                userNaturLoaded: false,
                userNaturLoading:true,
                userNaturError: '',
            };
        case USER_NATURALISTA_COUNT_LOADED:
            return {
                ...state,
                userNaturCount: action.payload,
                userNaturLoaded: true,
                userNaturLoading:false,
                userNaturError: '',
            };
        case USER_NATURALISTA_LOADED:
            return {
                ...state,
                userNatur: action.payload,
                userNaturLoaded: true,
                userNaturLoading:false,
                userNaturError: '',
            };
        case USER_NATURALISTA_ERROR:
            return {
                ...state,
                userNatur: [],
                userNaturLoaded: false,
                userNaturLoading: false,
                userNaturError: action.payload,
            };

        case USERS_TIPO_LOADING:
            return {
                ...state,
                tipouser: [],
                tipouser_load: false,
                tipouser_loading:true,
                tipouser_error: '',
            };
        case USERS_TIPO_LOADED:
            return {
                ...state,
                tipouser: action.payload,
                tipouser_load: true,
                tipouser_loading:false,
                tipouser_error: '',
            };
        case USERS_TIPO_ERROR:
            return {
                ...state,
                tipouser: [],
                tipouser_load: false,
                tipouser_loading: false,
                tipouser_error: action.payload,
            };

        case USER_EDIT_LOADING:
            return {
                ...state,
                isLoadingEdit: true,
                isLoadedEdit: false,
                userEdit: [],
                errorEdit: '',
            };
        case USER_EDIT_LOADED:
            return {
                ...state,
                isLoadingEdit: false,
                isLoadedEdit: true,
                userEdit: action.payload,
                errorEdit: '',
            };
        case USER_EDIT_ERROR:
            return {
                ...state,
                isLoadingEdit: false,
                isLoadedEdit: false,
                userEdit: [],
                errorEdit: action.payload,
            };

        case USER_EDIT_RESET:
            return {
                ...state,
                isLoadingEdit: false,
                isLoadedEdit: false,
                userEdit: [],
                errorEdit: ''
            };

        case USERALL_LOADING:
        case USER_LOADING:
            return {
                ...state,
                isLoading: true,
                error: ''
            };
        case USERALL_LOAD:
            return {
                ...state,
                userall: action.payload,
                isLoading: false,
                error: ''
            };
        case USER_LOADED:
            return {
                ...state,
                isLoading: false,
                isAuthenticated: true,
                user: action.payload,
                is_superuser: action.payload.is_superuser,
                tipo: action.payload.tipo
            };
        case USERALL_ERROR:
        case LOGIN_FAIL:
        case AUTH_ERROR:
            localStorage.removeItem('token');
            localStorage.removeItem('isAuthenticated');
            localStorage.removeItem('is_superuser');
            localStorage.removeItem('tipo');
            return {
                ...state,
                isLoading: false,
                isAuthenticated: false,
                user: null,
                token: null,
                is_superuser: null,
                tipo: null,
                error : action.payload,
            };
        case LOGIN_LOADING:
            return {
                ...state,
                isLoading: true,
            };
        case USER_LOADING:
            return {
                ...state,
                isLoading: true,
                error: ''
            };
        case LOGIN_SUCCESS:
            localStorage.setItem('token', action.payload.token);
            localStorage.setItem('isAuthenticated', action.payload.user.isAuthenticated);
            localStorage.setItem('is_superuser', action.payload.user.is_superuser);
            localStorage.setItem('tipo', action.payload.tipo);
            return {
                ...state,
                isLoading: false,
                isAuthenticated: true,
                is_superuser: action.payload.user.is_superuser,
                tipo: action.payload.user.tipo,
                user: action.payload.user,
                token: action.payload.token,
                error: '',
                ...action.payload
            };
        case LOGOUT_SUCCESS:
            localStorage.removeItem('token');
            localStorage.removeItem('isAuthenticated');
            localStorage.removeItem('is_superuser');
            localStorage.removeItem('tipo');
            return {
                ...state,
                isLoading: false,
                isAuthenticated: false,
                user: null,
                token: null,
                is_superuser: null,
                tipo: null,
                error: '',
            };
        default:
            return state;
    }
};